import React from 'react';

import { ProductForm } from './ProductForm';
import { FormModal } from '../common/form/FormModal';
import { ActionButton } from '../common/buttons/ActionButton';
import { ConfirmationActionButton } from '../common/buttons/ConfirmationActionButton';

import { remove as removeProduct, update as updateProduct } from '../../apis/products';
import { useModal } from '../../hooks/useModal';

export const ProductsListItem = ({ onRefresh, ...row }) => {
    const {
        showModal: showViewModal,
        handleShow: handleViewShow,
        handleHide: handleViewHide
    } = useModal();
    const {
        showModal: showEditModal,
        handleShow: handleEditShow,
        handleHide: handleEditHide
    } = useModal();

    const ProductFormModal = (props) => {
        return (
            <FormModal
                notificationTitle="Products"
                notificationIcon="icons"
                onSucceed={onRefresh}
                form={ProductForm}
                {...props}
            />
        );
    };

    const ViewActionButton = (props) => {
        return <ActionButton onClick={handleViewShow} tooltipText="View" {...props} />;
    };

    const EditActionButton = (props) => {
        return <ActionButton onClick={handleEditShow} tooltipText="Edit" {...props} />;
    };

    const RemoveActionButton = (props) => {
        return (
            <ConfirmationActionButton
                confirmationText={`Do you want to remove "${row.name}" product?`}
                notificationTitle="Products"
                notificationIcon="icons"
                tooltipText="Remove"
                action={() => removeProduct(row.id)}
                onSucceed={onRefresh}
                {...props}
            />
        );
    };

    return (
        <li className="list-group-item">
            <div className="row">
                <div className="icon-cell col-lg-1 col-xl-1">
                    <p className="text-center text-secondary mt-3 mt-lg-0">
                        <i className={`fad fa-${row.icon} fa-2x`}></i>
                    </p>
                </div>
                <div className="name-cell col-lg-8 col-xl-9 d-flex justify-content-between">
                    <label className="d-block d-lg-none fw-bold my-2">Name</label>
                    <p className="text-dark my-2">{row.name}</p>
                </div>
                <div className="actions-cell col-lg-3 col-xl-2 d-flex justify-content-between">
                    <label className="d-block d-lg-none fw-bold my-2">Actions</label>
                    <p className="text-end text-lg-center w-100 my-1">
                        <ViewActionButton className="btn btn-sm btn-outline-primary ms-2">
                            <span className="far fa-eye fa-fw"></span>
                        </ViewActionButton>
                        <EditActionButton className="btn btn-sm btn-outline-primary ms-2">
                            <span className="far fa-edit fa-fw"></span>
                        </EditActionButton>
                        <RemoveActionButton className="btn btn-sm btn-outline-primary ms-2">
                            <span className="far fa-trash fa-fw"></span>
                        </RemoveActionButton>
                    </p>
                </div>
                <div className="modal-wrappers">
                    <ProductFormModal
                        model={row}
                        mode="show"
                        title="View product"
                        show={showViewModal}
                        onHide={handleViewHide}
                    />
                    <ProductFormModal
                        model={row}
                        mode="edit"
                        title="Edit product"
                        action={updateProduct}
                        show={showEditModal}
                        onHide={handleEditHide}
                    />
                </div>
            </div>
        </li>
    );
};
